import React from 'react'
import { QuestionUtils } from '../../utils/siteUtils'
import Section, { StyledBlock, StyledH3, StyledValue } from './Section'
import { HistoryPageNumber } from '../../constants'
import styled from '@emotion/styled'

const VerifiedCheckyImage = __PATH_PREFIX__ + '/VerifiedChecky.svg'

const VehicleHistorySection = ({ navigatePageWithState, prospectDocuments, getQuestionResponse, canEdit, calculateViewChange, historyVerificationData, vinResults, qxData }) => {
  const splitItem = item => item.questionId.split('/')
  const getQid = item => splitItem(item)[1]

  // Hiding the following
  //Still Making Payments: qp / 82
  //Insurance Paid for repair : qp / 76
  //Complete Maintenance records: qp / 17
  const filtered =
    prospectDocuments &&
    prospectDocuments.documents &&
    prospectDocuments.documents[0].items.filter(item => splitItem(item).length <= 2 && item.questionId !== 'qp/65' && item.questionId !== 'qp/79' && item.questionId !== 'qp/82' && item.questionId !== 'qp/76' && item.questionId !== 'qp/17')
  const childQuestions = prospectDocuments && prospectDocuments.documents && prospectDocuments.documents[0].items.filter(item => !(splitItem(item).length <= 2))
  const parent = filtered && filtered.map(item => ({ parent: item, child: childQuestions.filter(item2 => getQid(item2) === getQid(item)) }))

  let uniqueViewStr = 'uniqueViewStr:'
  const component = (
    <Section title={'Vehicle History'} showEdit={canEdit} onClick={e => navigatePageWithState({ p: HistoryPageNumber })}>
      {parent &&
        parent.map((question, index) => {
          const { questionLabel, questionId, questionChoices } = QuestionUtils.getQuestionLabelAndChoices(question.parent)
          const questionValue = questionChoices[getQuestionResponse(questionId).v]
          const questionValueString = typeof questionValue === 'string' ? questionValue : questionValue ? 'Yes' : 'No'
          const verifiedAnswerSources = prospectDocuments && prospectDocuments.wipReadback.answers.find(q => q.qRef === 'qx/AnswerSources')
          const verifiedAnswer = verifiedAnswerSources && JSON.parse(verifiedAnswerSources.value).find(q => q.QuestionCode === question.parent.questionId)
          let dealerChangedAccidents
          if (historyVerificationData == null) {
            const answerSourceInput = qxData.find(data => data.questionId === 'qx/AnswerSourcesInput')
            const answeredIncident = answerSourceInput.value.find(data => data.questionCode === 'DealerModifiedAccidentQuestion')
            dealerChangedAccidents = answeredIncident.value
          } else {
            dealerChangedAccidents = historyVerificationData && historyVerificationData.hasAccidents === false && getQuestionResponse('qp/124').v === 0
          }

          uniqueViewStr = uniqueViewStr + questionLabel + questionValueString
          return (
            <React.Fragment key={index}>
              <StyledBlock>
                <StyledH3>
                  {question && ['qp/124'].indexOf(question.parent.questionId) !== -1 && (historyVerificationData || verifiedAnswer) && !dealerChangedAccidents && (
                    <VerifiedByIconDiv>
                      <img src={VerifiedCheckyImage} height="15px" alt="checkmark" />
                    </VerifiedByIconDiv>
                  )}
                  {question && ['qp/83', 'qp/125'].indexOf(question.parent.questionId) !== -1 && (historyVerificationData || verifiedAnswer) && (
                    <VerifiedByIconDiv>
                      <img src={VerifiedCheckyImage} height="15px" alt="checkmark" />
                    </VerifiedByIconDiv>
                  )}
                  {question && ['qp/81'].indexOf(question.parent.questionId) !== -1 && ((vinResults && vinResults.vehicleActivityApplicationDown === false) || verifiedAnswer) && (
                    <VerifiedByIconDiv>
                      <img src={VerifiedCheckyImage} height="15px" alt="checkmark" />
                    </VerifiedByIconDiv>
                  )}
                  {questionLabel}
                </StyledH3>
                <StyledValue>{questionValueString}</StyledValue>
              </StyledBlock>
              {question.child &&
                getQuestionResponse(questionId).v === 0 &&
                question.child.map((child, index2) => {
                  const questionValue = getQuestionResponse(child.questionId) && getQuestionResponse(child.questionId).v
                  uniqueViewStr = uniqueViewStr + (child && child.label) + questionValue
                  return (
                    <StyledBlock key={index2}>
                      <StyledH3>{child && child.label}</StyledH3>
                      <StyledValue>{questionValue}</StyledValue>
                    </StyledBlock>
                  )
                })}
            </React.Fragment>
          )
        })}
    </Section>
  )

  calculateViewChange('vehicleHistory', parent && uniqueViewStr)

  return component
}
const VerifiedByIconDiv = styled.span`
  margin-right: 15px;
`
export default VehicleHistorySection
